interface Properties {
  height?: number;
  width?: number;
  color?: string;
}

/** Exact "align-left 1" asset from the Variance modal's Indent Figma frame. */
const RightIndent = ({ height = 14, width = 14, color = 'black' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.583333 3.5H13.4167C13.5714 3.5 13.7197 3.43854 13.8291 3.32915C13.9385 3.21975 14 3.07138 14 2.91667C14 2.76196 13.9385 2.61358 13.8291 2.50419C13.7197 2.39479 13.5714 2.33333 13.4167 2.33333H0.583333C0.428623 2.33333 0.28025 2.39479 0.170854 2.50419C0.061458 2.61358 0 2.76196 0 2.91667C0 3.07138 0.061458 3.21975 0.170854 3.32915C0.28025 3.43854 0.428623 3.5 0.583333 3.5Z'
        fill={color}
      />
      <path
        d='M0.583333 6.41667H8.75C8.90471 6.41667 9.05308 6.35521 9.16248 6.24581C9.27187 6.13642 9.33333 5.98804 9.33333 5.83333C9.33333 5.67862 9.27187 5.53025 9.16248 5.42085C9.05308 5.31146 8.90471 5.25 8.75 5.25H0.583333C0.428623 5.25 0.28025 5.31146 0.170854 5.42085C0.061458 5.53025 0 5.67862 0 5.83333C0 5.98804 0.061458 6.13642 0.170854 6.24581C0.28025 6.35521 0.428623 6.41667 0.583333 6.41667Z'
        fill={color}
      />
      <path
        d='M8.75 11.0833H0.583333C0.428623 11.0833 0.28025 11.1448 0.170854 11.2542C0.061458 11.3636 0 11.512 0 11.6667C0 11.8214 0.061458 11.9697 0.170854 12.0791C0.28025 12.1885 0.428623 12.25 0.583333 12.25H8.75C8.90471 12.25 9.05308 12.1885 9.16248 12.0791C9.27187 11.9697 9.33333 11.8214 9.33333 11.6667C9.33333 11.512 9.27187 11.3636 9.16248 11.2542C9.05308 11.1448 8.90471 11.0833 8.75 11.0833Z'
        fill={color}
      />
      <path
        d='M13.4167 8.16667H0.583333C0.428623 8.16667 0.28025 8.22813 0.170854 8.33752C0.061458 8.44692 0 8.59529 0 8.75C0 8.90471 0.061458 9.05308 0.170854 9.16248C0.28025 9.27188 0.428623 9.33333 0.583333 9.33333H13.4167C13.5714 9.33333 13.7197 9.27188 13.8291 9.16248C13.9385 9.05308 14 8.90471 14 8.75C14 8.59529 13.9385 8.44692 13.8291 8.33752C13.7197 8.22813 13.5714 8.16667 13.4167 8.16667Z'
        fill={color}
      />
    </svg>
  );
};

export default RightIndent;
